import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	disabledTabContent: {
		background: '#fff',
		minHeight: 300,
		position: 'relative',
	},
});
